import { getConfig } from "../env/envManager";
import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { UserData } from '../dto/EntityRepository';
import { PasswordStatus } from '../enum/EnumRepository';


interface AuthStore {
  user: UserData | null;
  setUser: (user: UserData | null) => void;
  clearUser: () => void;
  setPasswordStatus: (status: PasswordStatus) => void;
}

/*
  name        : sessionStorage key
  storage     : sessionStorage 사용
  partialize  : user 필드만 저장 (필요한 경우)
*/
export const useAuthStore = create<AuthStore>()(
  // devtools:
  // 개발 환경에서 유용하며, 
  // 프로덕션에서는 추가 설정으로 비활성화할 수 있다.
  devtools(
    persist(
      (set) => ({
        user: null,
        setUser: (u) => set({ user: u }),
        setPasswordStatus: (status) => set((state) => ({
          user: state.user ? { ...state.user, passwordStatus: status } : state.user
        })),
        clearUser: () => set({ user: null }),
      }),
      {
        name: `architrave-${getConfig().version}-user`,
        storage: createJSONStorage(() => sessionStorage),
        partialize: (s) => ({ user: s.user }),
      }
    )
  )
);

//----- authToken -----
interface AuthTokenStore {
  authToken: string | null;
  setAuthToken: (token: string | null) => void;
  clearAuthToken: () => void;
}

export const useAuthTokenStore = create<AuthTokenStore>((set) => ({
  authToken: null,
  setAuthToken: (token) => set({ authToken: token }),
  clearAuthToken: () => set({ authToken: null }),
}));

//----- editMode -----
interface EditModeStore {
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
}

export const useEditModeStore = create<EditModeStore>((set) => ({
  isEditMode: false,
  setIsEditMode: (value) => set({ isEditMode: value }),
}));

//----- Menu -----
interface MenuToggleState {
  isMenuOpen: boolean;
  setIsMenuOpen: (value: boolean) => void;
}

export const useMenuToggleStore = create<MenuToggleState>((set) => ({
  isMenuOpen: false,
  setIsMenuOpen: (value) => set({ isMenuOpen: value }),
}));

//----- guideMode -----
interface GuideModeStore {
  isGuideMode: boolean;
  setIsGuideMode: (value: boolean) => void;
}

export const useGuideModeStore = create<GuideModeStore>((set) => ({
  isGuideMode: false,
  setIsGuideMode: (value) => set({ isGuideMode: value }),
}));
